var _path, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsSummaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 37,
    viewBox: "0 0 40 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6522 0H4.34783C3.19513 0.00135778 2.09003 0.459867 1.27495 1.27495C0.459867 2.09003 0.00135778 3.19513 0 4.34783V23.4783C0.00135778 24.631 0.459867 25.7361 1.27495 26.5511C2.09003 27.3662 3.19513 27.8247 4.34783 27.8261H6.08696V34.7436C6.08372 35.098 6.18719 35.4453 6.38393 35.7401C6.58066 36.035 6.86155 36.2639 7.19009 36.397C7.50812 36.5253 7.85744 36.5548 8.19249 36.4816C8.52754 36.4084 8.83276 36.236 9.06835 35.9868L16.8929 27.8261H35.6522C36.8049 27.8247 37.91 27.3662 38.7251 26.5511C39.5401 25.7361 39.9986 24.631 40 23.4783V4.34783C39.9986 3.19513 39.5401 2.09003 38.7251 1.27495C37.91 0.459867 36.8049 0.00135778 35.6522 0ZM38.2609 23.4783C38.2601 24.1699 37.985 24.833 37.496 25.3221C37.0069 25.8111 36.3438 26.0862 35.6522 26.087H16.5217C16.4045 26.087 16.2885 26.1107 16.1807 26.1566C16.0728 26.2026 15.9754 26.2699 15.8942 26.3544L7.82609 34.7436V26.9565C7.82616 26.8423 7.80371 26.7292 7.76003 26.6237C7.71636 26.5181 7.65231 26.4223 7.57155 26.3415C7.49079 26.2607 7.3949 26.1967 7.28937 26.153C7.18384 26.1093 7.07073 26.0869 6.95652 26.087H4.34783C3.65619 26.0862 2.9931 25.8111 2.50404 25.3221C2.01498 24.833 1.73989 24.1699 1.73913 23.4783V4.34783C1.73989 3.65619 2.01498 2.9931 2.50404 2.50404C2.9931 2.01498 3.65619 1.73989 4.34783 1.73913H35.6522C36.3438 1.73989 37.0069 2.01498 37.496 2.50404C37.985 2.9931 38.2601 3.65619 38.2609 4.34783V23.4783Z",
    fill: "#4D5152"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 8,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#51ACFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 13,
    width: 27,
    height: 2,
    rx: 1,
    fill: "#51ACFC"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 18,
    width: 27,
    height: 2,
    rx: 1,
    fill: "#51ACFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsSummaryIcon);
export default __webpack_public_path__ + "static/media/sms-summary-icon.57985f4192fe1dc337339b74273d3a0c.svg";
export { ForwardRef as ReactComponent };